module.exports = __webpack_public_path__ + "static/img/xl3.adb911a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl3.jpg
// module id = ZAg7
// module chunks = 1